import { IAdminRepository } from "@/repositories/admin";
import { AdminListGroupsForUserResponse, ListGroupsResponse, UsersListType } from "aws-sdk/clients/cognitoidentityserviceprovider";
import { IAdminService } from "./admin.types";

export class AdminService implements IAdminService {
    constructor(private repository: IAdminRepository){}
    async getListUserInGroup(groupName: string): Promise<UsersListType> {
        console.log("getListUserInGroup")
        let userList: UsersListType = [];
        let token: string | undefined;
        do {
            const {Users, NextToken}  = await this.repository.listUsersInGroup(groupName, token);
            if(Users){
                userList = [...userList, ...Users];
            }
            token = NextToken;
        } while (token);
        // console.log(userList);
        return userList;
    }
    async getListGroup(): Promise<ListGroupsResponse> {
        return await this.repository.listGroups();
    }
    async addUserToGroup(username: string, groupName: string): Promise<void> {
        await this.repository.adminAddUserToGroup(username, groupName);
    }
    async removeUserFromGroup(username: string, groupName: string): Promise<void> {
        await this.repository.adminRemoveUserFromGroup(username, groupName);
    }
    async getUserList(): Promise<UsersListType> {
        let userList: UsersListType = [];
        let token: string | undefined;
        do {
            const {Users, PaginationToken} = await this.repository.listUser(token);
            if(Users){
                userList = [...userList, ...Users];
            }
            token = PaginationToken;
        } while (token);
        console.log(userList);
        return userList;
    }
    async enableUser(username: string): Promise<void> {
        await this.repository.adminEnableUser(username);
    }
    async disableUser(username: string): Promise<void> {
        await this.repository.adminDisableUser(username);
    }
    async getGroupList(username: string): Promise<AdminListGroupsForUserResponse> {
        return await this.repository.adminListGroupsForUser(username);
    }
    async updateUserAttributes(username: string, name: string, value: string): Promise<void> {
        return await this.repository.adminUpdateUserAttributes(username, name, value);
    }
}